import React, { Component } from 'react';
import { formatVietnameseDate, isValidDate, renderRank, renderRankHtml } from '@/utils/helpers';

class PrintOrthoPlan extends Component {

    render() {
        const { customer, data } = this.props;

        const patient_allergy_info = data?.patient_allergy_info || [];
        const ly_do_vao_vien = data?.ly_do_vao_vien || '';
        const hoi_benh = data?.hoi_benh || '';
        const tien_su_benh_lien_quan = data?.tien_su_benh_lien_quan || [];
        const mach = data?.mach || '';
        const nhiet_do = data?.nhiet_do || '';
        const huyet_ap = data?.huyet_ap || '';
        const nhip_tho = data?.nhip_tho || '';
        const can_nang = data?.can_nang || '';
        const chieu_cao = data?.chieu_cao || '';
        const toan_than = data?.toan_than || [];
        const kham_chuyen_khoa = data?.kham_chuyen_khoa || [];
        const cac_xet_nghiem_can_lam = data?.cac_xet_nghiem_can_lam || [];
        const tom_tat_benh_an = data?.tom_tat_benh_an || '';
        const benh_chinh = data?.benh_chinh || '';
        const benh_chinh_code = data?.benh_chinh_code || '';
        const benh_kem_theo = data?.benh_kem_theo || '';
        const benh_kem_theo_code = data?.benh_kem_theo_code || '';
        const bien_chung = data?.bien_chung || '';
        const bien_chung_code = data?.bien_chung_code || '';
        const ke_hoach_dieu_tri = data?.ke_hoach_dieu_tri || '';
        const qua_trinh_dieu_tri = data?.qua_trinh_dieu_tri || [];
        const thoi_gian_dieu_tri_start = data?.thoi_gian_dieu_tri_start || '';
        const thoi_gian_dieu_tri_end = data?.thoi_gian_dieu_tri_end || '';
        const tom_tat_qua_trinh_benh_ly = data?.tom_tat_qua_trinh_benh_ly || '';
        const dau_hieu_lam_sang = data?.dau_hieu_lam_sang || '';
        const tom_tat_ket_qua_xet_nghiem = data?.tom_tat_ket_qua_xet_nghiem || '';
        const phuong_phap_dieu_tri = data?.phuong_phap_dieu_tri || [];
        const tinh_trang_ra_vien = data?.tinh_trang_ra_vien || '';
        const huong_dieu_tri_tiep_theo = data?.huong_dieu_tri_tiep_theo || '';

        const created_at = data?.created_at || '';
        const doctor = data?.doctor?.full_name || '';

        const addressParts = [
            customer?.address?.trim(),
            customer?.hamlet?.trim(),
            customer?.wards_name?.trim(),
            customer?.province_name?.trim(),
        ];

        // Lọc bỏ phần rỗng hoặc undefined, rồi nối bằng dấu phẩy
        const address = addressParts.filter(Boolean).join(', ') || '-';

        return (
            <div className="container print-content">

                <div className="header">
                    <div className="logo-box">
                        <img src="https://chingodental.vn/Logo-fanpage-2.png" alt="Logo Chingo Dental" />
                    </div>

                    <div className="footer">
                        <div className="qr-box">
                            <img src="https://chingodental.vn/QRCode.jpg" alt="QR Code" />
                        </div>

                        <div className="clinic">
                            <div className="section-title">NHA KHOA CHINGO</div>
                            <span>CS1: Số 560 Nguyễn Văn Cừ, Phường Bồ Đề, TP. Hà Nội</span>
                            <span>Hotline: 0978 009 780</span>
                            <span>CS2: Số 22 Lê Hồng Phong, Phường Hải Châu, TP. Đà Nẵng</span>
                            <span>Hotline: 0916 019 696</span>
                            <span>CS3: Số 17 Lý Nam Đế, Phường Hội An, TP. Đà Nẵng</span>
                            <span>Hotline: 0916 019 696</span>
                        </div>
                    </div>
                </div>

                <div className="title-wrap">
                    <h1>BỆNH ÁN TỔNG QUÁT</h1>
                </div>


                <h2 className="section-title">A. THÔNG TIN CHUNG</h2>
                <table className="kv-table mb-4">
                    <tr>
                        <th>Họ và tên khách hàng</th>
                        <td><strong>{customer?.full_name}</strong></td>
                    </tr>
                    <tr>
                        <th>Mã khách hàng</th>
                        <td>{customer?.code}</td>
                    </tr>
                    <tr>
                        <th>Số CCCD/CMND</th>
                        <td>{customer?.identity_number}</td>
                    </tr>
                    <tr>
                        <th>Ngày sinh</th>
                        <td>{isValidDate(customer?.birthday, false)}</td>
                    </tr>
                    <tr>
                        <th>Tuổi</th>
                        <td>{customer?.age}</td>
                    </tr>
                    <tr>
                        <th>Địa chỉ</th>
                        <td>{address}</td>
                    </tr>
                </table>


                <h2 className="section-title">PHIẾU KHAI THÁC TIỀN SỬ DỊ ỨNG</h2>
                <table className="custom-table">
                    <thead>
                        <tr>
                            <th>STT</th>
                            <th>Nội dung</th>
                            <th>Tên thuốc, dị nguyên</th>
                            <th>Dị ứng?</th>
                            <th>Số lần</th>
                            <th>Biểu hiện lâm sàng - xử trí</th>
                        </tr>
                    </thead>
                    <tbody>
                        {patient_allergy_info && patient_allergy_info.length > 0 && patient_allergy_info.map((item, index) => (
                            <tr key={index} style={{ textAlign: 'left' }}>
                                <td style={{ textAlign: 'center', width: '40px' }}>{index + 1}</td>
                                <td>{item.content}</td>
                                <td>{item.allergen_name}</td>
                                <td>{item.has_occurrence}</td>
                                <td>{item.occurrence_count}</td>
                                <td>{item.clinical_signs}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                <h2 className="section-title">B. THÔNG TIN KHÁM BỆNH</h2>
                <div className="section-subtitle"><strong>I. LÝ DO VÀO VIỆN, VẤN ĐỀ SỨC KHỎE:</strong></div>
                <div className="mb-4">{ly_do_vao_vien}</div>

                <div className='section-subtitle'><strong>II. HỎI BỆNH</strong></div>
                <div className="mb-2"><strong>1. Quá trình bệnh lý và diễn biến lâm sàng</strong> <span style={{ fontStyle: 'italic' }}>(Đặc điểm khởi phát, các triệu chứng lâm sàng, diễn biến bệnh...)</span>:</div>
                <div className='mb-4'>{hoi_benh}</div>

                <div className="mb-2"><strong>2. Tiền sử có liên quan đến tình trạng bệnh lần này: </strong></div>
                <div className='mb-4' dangerouslySetInnerHTML={{
                    __html: renderRankHtml(tien_su_benh_lien_quan),
                }} />

                <div className='section-subtitle'><strong>III. KHÁM BỆNH</strong></div>
                <div className='mb-2'><strong>Mạch (lần/phút): </strong>{mach}</div>
                <div className='mb-2'><strong>Nhiệt độ (°C): </strong>{nhiet_do}</div>
                <div className='mb-2'><strong>Huyết áp (mmHg): </strong>{huyet_ap}</div>
                <div className='mb-2'><strong>Nhịp thở (lần/phút): </strong>{nhip_tho}</div>
                <div className='mb-2'><strong>Cân nặng (kg): </strong>{can_nang}</div>
                <div className='mb-4'><strong>Chiều cao (cm): </strong>{chieu_cao}</div>

                <div className="mb-4"><strong>1. Toàn thân: </strong>{renderRank(toan_than)}</div>
                <div className="mb-4"><strong>2. Khám chuyên khoa: </strong>{renderRank(kham_chuyen_khoa)}</div>
                <div className="mb-4"><strong>3. Các xét nghiệm, cận lâm sàng cần làm: </strong>{renderRank(cac_xet_nghiem_can_lam)}</div>
                <div className="mb-4"><strong>4. Tóm tắt bệnh án: </strong>{tom_tat_benh_an}</div>

                <div className='section-subtitle'><strong>IV. CHẨN ĐOÁN (Tên bệnh kèm theo mã ICD)</strong></div>
                <div className="mb-4"><strong>1. Bệnh chính: </strong>{benh_chinh}
                    {benh_chinh_code && (<>(Mã ICD: {benh_chinh_code})</>)}
                </div>
                <div className="mb-4"><strong>2. Bệnh kèm theo (nếu có): </strong>{benh_kem_theo}
                    {benh_kem_theo_code && (<>(Mã ICD: {benh_kem_theo_code})</>)}
                </div>
                <div className="mb-4"><strong>3. Biến chứng (nếu có): </strong>{bien_chung}
                    {bien_chung_code && (<>(Mã ICD: {bien_chung_code})</>)}
                </div>

                <div className='section-subtitle'><strong>V. KẾ HOẠCH ĐIỀU TRỊ</strong></div>
                <div className="mb-4">{ke_hoach_dieu_tri}</div>

                <div className="section-subtitle"><strong>VI. QUÁ TRÌNH ĐIỀU TRỊ</strong></div>
                <table className="custom-table">
                    <thead>
                        <tr>
                            <th>Ngày</th>
                            <th>Diễn biến bệnh</th>
                            <th>Xử trí</th>
                            <th>Ghi chú</th>
                        </tr>
                    </thead>
                    <tbody>
                        {qua_trinh_dieu_tri && qua_trinh_dieu_tri.length > 0 && qua_trinh_dieu_tri.map((item, index) => (
                            <tr key={index} style={{ textAlign: 'left' }}>
                                <td>{isValidDate(item.ngay, false)}</td>
                                <td>{item.dien_bien_benh}</td>
                                <td>{item.xu_tri}</td>
                                <td>{item.note}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                <div className="section-subtitle mt-4"><strong>VII. THỜI GIAN ĐIỀU TRỊ: </strong></div>
                <div className="mb-4">Từ ngày: {isValidDate(thoi_gian_dieu_tri_start, false)} đến ngày {isValidDate(thoi_gian_dieu_tri_end, false)}</div>

                <div className="section-subtitle mt-4"><strong>C. TỔNG KẾT BỆNH ÁN</strong></div>

                <div className="mb-2"><strong>1. Tóm tắt quá trình bệnh lý và diễn biến lâm sàng</strong> <span style={{ fontStyle: 'italic' }}>(Đặc điểm khởi phát, các triệu chứng lâm sàng, diễn biến bệnh...): </span></div>
                <div className='mb-4'>{tom_tat_qua_trinh_benh_ly}</div>

                <div className="mb-2"><strong>2. Những dấu hiệu lâm sàng chính được ghi nhận</strong> <span style={{ fontStyle: 'italic' }}>(có giá trị chẩn đoán trong quá trình điều trị): </span></div>
                <div className='mb-4'>{dau_hieu_lam_sang}</div>

                <div className="mb-2"><strong>3. Tóm tắt kết quả xét nghiệm, cận lâm sàng có giá trị chẩn đoán: </strong></div>
                <div className='mb-4'>{tom_tat_ket_qua_xet_nghiem}</div>

                <div className="mb-2"><strong>4. Phương pháp điều trị (tương ứng với chẩn đoán): </strong></div>
                <div className='mb-4'>{renderRank(phuong_phap_dieu_tri)}</div>

                <div className="mb-2"><strong>5. Tình trạng ra viện</strong></div>
                {tinh_trang_ra_vien && <div className="mb-4">{tinh_trang_ra_vien}</div>}

                <div className="mb-2"><strong>6. Hướng điều trị và các chế độ tiếp theo</strong></div>
                <div className='mb-2'>{huong_dieu_tri_tiep_theo}</div>

                <div className="print-date">
                    .............., ngày {formatVietnameseDate(created_at)}
                </div>


                <div className="signature-section mt-4">
                    <div className="sig-box">
                        <strong>Bác sĩ</strong>
                        <span className="note">(Ký, ghi rõ họ tên)</span>
                        <div className="sig-space"></div>
                        <div className="sig-name">{doctor}</div>
                    </div>

                    <div className="sig-box">
                        <strong>Khách hàng</strong>
                        <span className="note">(Ký, ghi rõ họ tên)</span>
                        <div className="sig-space"></div>
                        <div className="sig-name">{customer?.full_name}</div>
                    </div>
                </div>

                <style>
                    {`
                        /* --- Print & Page setup --- */
                        @page {
                            size: A4;
                            margin: 1cm 1.5cm 1.8cm 1.8cm;
                            /* top right bottom left */
                        }

                        :root {
                            --text: #111;
                            --muted: #666;
                            --border: #ddd;
                            --heading: #000;
                            --primary: #0b2b33;
                        }

                        @media print {
                            .no-print {
                                display: none !important;
                            }

                            .page-break {
                                page-break-before: always;
                            }
                            
                            body {
                                font-family: "Times New Roman", serif;
                                font-size: 12pt;
                                line-height: 1.5;
                                color: #000;
                               /*  width: 210mm;
                                border: 1px solid #dedede; */
                            }
                        }

                        .container {
                            max-width: 800px;
                            margin: 0 auto;
                            padding: 0;
                            position: relative;
                        }

                        .print-content h1,
                        .print-content h2,
                        .print-content h3 {
                            margin: 0 0 10px 0;
                            color: var(--heading);
                        }

                        .print-content h1 {
                            text-align: center;
                            font-size: 18pt;
                            letter-spacing: 0.3px;
                        }

                        .print-content h2.section-title {
                            font-size: 13.5pt;
                            /* border-left: 4px solid var(--primary);
                            padding-left: 8px; */
                            margin: 18px 0 10px 0;
                        }

                        .print-content .line-height-20{
                            line-height: 20px;
                        }
                        .subtitle {
                            color: var(--muted);
                            font-style: italic;
                            font-weight: normal;
                            margin-left: 6px;
                            font-size: 11.5pt;
                        }

                        /* --- Header --- */
                    .header {
                        display: flex;
                        align-items: flex-start;
                        justify-content: space-between;
                        margin-bottom: 20px;
                        border-bottom: 1px solid var(--border);
                        padding-bottom: 20px;
                        position: relative;
                    }

                    /* Nhóm bên phải (QR + thông tin) */
                    .header .footer {
                        display: flex;
                        align-items: flex-start;
                        gap: 16px;
                        border: none;
                        padding-top: 0;
                        margin-top: 0;
                    }

                    /* Logo */
                    .logo-box {
                        width: 90px;
                        height: 90px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        flex-shrink: 0;
                    }

                    .logo-box img {
                        max-width: 100%;
                        max-height: 100%;
                        object-fit: contain;
                    }

                    /* QR */
                    .header .footer .qr-box {
                        width: 80px;
                        height: 80px;
                        flex-shrink: 0;
                    }

                    .header .footer .qr-box img {
                        width: 100%;
                        height: 100%;
                        object-fit: contain;
                        border: 1px solid var(--border);
                        background: #fff;
                        padding: 4px;
                    }

                    /* Clinic info */
                    .header .footer .clinic {
                        text-align: left;
                        margin-left: 8px;
                        font-size: 10.5pt;
                        line-height: 1.4;
                    }

                    .header .footer .clinic .section-title {
                        font-weight: bold;
                        color: var(--primary);
                        margin-bottom: 4px;
                        font-size: 11pt;
                    }

                    .header .footer .clinic span {
                        display: block;
                        font-size: 8px;
                        color: var(--muted);
                        line-height: 1.3;
                    }
                        .title-wrap {
                            margin: 8px 0 16px 0;
                        }

                        /* --- Tables --- */
                        table {
                            border-collapse: collapse;
                            width: 100%;
                        }

                        .kv-table td,
                        .kv-table th {
                            border: 0px solid var(--border);
                            padding: 5px 0px;
                            vertical-align: top;
                        }

                        .kv-table th {
                            width: 32%;
                            /* background: #fafafa; */
                            text-align: left;
                            font-weight: 600;
                        }

                        .grid-table th,
                        .grid-table td {
                            border: 1px solid var(--border);
                            padding: 6px 8px;
                            vertical-align: top;
                        }

                        .grid-table th {
                            background: #fafafa;
                        }

                        .narrow td,
                        .narrow th {
                            padding: 5px 6px;
                        }

                        .muted {
                            color: var(--muted);
                        }

                        /* --- Helpers --- */
                        .mb-4 {
                            margin-bottom: 16px;
                        }

                        .mb-2 {
                            margin-bottom: 8px;
                        }

                        .mt-2 {
                            margin-top: 8px;
                        }

                        .mt-4 {
                            margin-top: 16px;
                        }

                        .pt-2 {
                            padding-top: 8px;
                        }

                        .pt-4 {
                            padding-top: 16px;
                        }

                        .pl-2 {
                            padding-left: 8px;
                        }

                        .pl-4 {
                            padding-left: 16px;
                        }

                        .pr-2 {
                            padding-right: 8px;
                        }

                        .pr-4 {
                            padding-right: 16px;
                        }

                        .italic {
                            font-style: italic;
                        }

                        .center {
                            text-align: center;
                        }

                        .right {
                            text-align: right;
                        }

                        .checkbox {
                            font-family: "Segoe UI Symbol", "DejaVu Sans", "Times New Roman";
                        }

                        .note {
                            color: var(--muted);
                        }

                        .image-strip {
                            display: flex;
                            flex-wrap: wrap;
                            gap: 8px;
                            border: 1px dashed var(--border);
                            padding: 10px;
                            min-height: 48px;
                        }

                        .image-thumb {
                            width: 110px;
                            height: 85px;
                            border: 1px solid var(--border);
                            display: inline-flex;
                            align-items: center;
                            justify-content: center;
                            font-size: 10pt;
                            color: var(--muted);
                            background: #fff;
                        }

                        /* --- Textareas-like blocks --- */
                        .textblock {
                            min-height: 64px;
                            border: 1px solid var(--border);
                            padding: 8px;
                            white-space: pre-wrap;
                        }

                        .textblock.tall {
                            min-height: 96px;
                        }

                        .disease-grid {
                            display: flex;
                            gap: 16px;
                            justify-content: space-between;
                        }

                        .disease-column {
                            flex: 1;
                        }

                        .disease-column table {
                            width: 100%;
                        }

                        .disease-column td strong {
                            margin-right: 4px;
                            color: var(--primary);
                        }

                        @media print {
                            .disease-grid {
                                page-break-inside: avoid;
                            }
                        }

                        .bite-item {
                            justify-content: space-between;
                            padding: 6px 0;
                        }

                        .bite-item:last-child {
                            border-bottom: none;
                        }

                        .bite-label {
                            flex: 1;
                            color: var(--text);
                        }

                        .bite-value {
                            min-width: 60px;
                            text-align: right;
                            font-weight: bold;
                            color: var(--primary);
                        }

                        .section-subtitle {
                            font-size: 12pt;
                            margin-bottom: 6px;
                        }

                        .print-date {
                            text-align: right;
                            margin-top: 40px;
                            font-size: 12pt;
                            font-style: italic;
                            color: var(--text);
                        }

                        .signature-section {
                            display: flex;
                            justify-content: space-between;
                            align-items: flex-start;
                            margin-top: 30px;
                            text-align: center;
                            gap: 60px;
                            margin-bottom: 50px;
                        }

                        .sig-box {
                            flex: 1;
                        }

                        .sig-box strong {
                            font-size: 13pt;
                            display: block;
                            margin-bottom: 2px;
                        }

                        .sig-box .note {
                            color: var(--muted);
                            font-style: italic;
                            font-size: 11pt;
                        }

                        .sig-space {
                            height: 60px;
                            margin: 24px auto 8px auto;
                            width: 80%;
                        }

                        .sig-name {
                            font-weight: bold;
                            font-size: 12pt;
                            color: var(--primary);
                            text-transform: uppercase;
                        }
                        
                         .custom-table {
                            border-collapse: collapse;
                            width: 100%;
                            margin: 10px auto 40px auto;
                            background-color: #fff;
                        }

                        .custom-table .section-subtitle{
                            font-size: 11.5pt;
                        }

                        .custom-table td:first-child {
                            vertical-align: middle;
                            font-weight: bold;
                            width: 10%;
                        }

                        .custom-table th,
                        .custom-table td {
                            border: 1px solid #ccc;
                            padding: 10px 12px;
                            vertical-align: middle;
                            text-align: left;
                        }

                        .custom-table th {
                            text-align: center;
                        }

                        .custom-table  sup {
                            font-size: 0.7em;
                            color: #555;
                    }

                    `}
                </style>
            </div >
        );
    }
}

export default PrintOrthoPlan;
